import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewAgentMarginDetailsList = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_AGENT_MARGIN_DETAILS_LIST_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(
        `${BASE_URL}/agent-margin-details/list`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_AGENT_MARGIN_DETAILS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_AGENT_MARGIN_DETAILS_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_AGENT_MARGIN_DETAILS_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewAgentMarginDetails = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_AGENT_MARGIN_DETAILS_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.get(
        `${BASE_URL}/agent-margin-details/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_AGENT_MARGIN_DETAILS_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_AGENT_MARGIN_DETAILS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_AGENT_MARGIN_DETAILS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addNewAgentMarginDetails = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_AGENT_MARGIN_DETAILS_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(
        `${BASE_URL}/agent-margin-details/add`,
        payload,
        config
      );

      dispatch({ type: "ADD_AGENT_MARGIN_DETAILS_SUCCESS", payload: data });
      return { statusCode: data.statusCode };
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error.message ||
        "Failed to add agent margin details";

      dispatch({ type: "ADD_AGENT_MARGIN_DETAILS_FAILED", payload: errorMessage });
      throw error;
    }
  };
};

export const updateAgentMarginDetails = (id, payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_AGENT_MARGIN_DETAILS_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(
        `${BASE_URL}/agent-margin-details/update`,
        { id, ...payload },
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_AGENT_MARGIN_DETAILS_SUCCESS", payload: data });
        toast.success("Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_AGENT_MARGIN_DETAILS_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_AGENT_MARGIN_DETAILS_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    }
  };
};